import React from 'react';
import { Trash2 } from 'lucide-react';

const DeleteGroupModal = ({ onClose, onDelete, group, actionLoading }) => {
  return (
    <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-sm">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-errorLight mb-4">
            <Trash2 className="h-6 w-6 text-error" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Delete Group</h3>
          <p className="text-sm text-gray-500 mb-6">
            Are you sure you want to delete <strong>{group.group_name}</strong>? This action cannot be undone.
          </p>
          <div className="flex gap-3">
            <button
              onClick={onDelete}
              disabled={actionLoading}
              className="flex-1 bg-error hover:bg-errorDark disabled:bg-gray-400 text-white px-4 py-2 rounded-lg font-medium flex items-center justify-center gap-2 transition-colors"
            >
              {actionLoading ? (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              ) : (
                <Trash2 className="w-4 h-4" />
              )}
              Delete
            </button>
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteGroupModal;